import Vue from 'vue';
import router from '../router';
import { Route } from 'vue-router';
import { APPLICATION_USER_DATA } from '@/queries/Application';
import gql from 'graphql-tag';

const ORDER_UNIT = gql`
  query orderUnit($id: ID!) {
    order(id: $id) {
      id
      unit {
        id
      }
    }
  }
`;

const sameUnitOrdersGuard = (
  to: Route,
  from: Route,
  next: (to?: string | false | void | ((vm: Vue) => void)) => void,
): Promise<boolean> => {
  const loader = router.app.$sLoader({
    show: true,
    fullPage: true,
    element: router.app.$el as HTMLElement,
  });
  const applicationUserDataQuery = router.app.$apollo.query({
    query: APPLICATION_USER_DATA,
  });
  const orderQuery = router.app.$apollo.query({
    query: ORDER_UNIT,
    variables: { id: to.params.id },
    fetchPolicy: 'no-cache',
  });
  return Promise.all([ applicationUserDataQuery, orderQuery ]).then(response => {
    const currentUser = response[0].data.currentUser;
    const orderData = response[1].data;
    if (orderData.order.unit.id !== currentUser.currentUnit.id) {
      next(false);
      router.push({ name: 'Orders' });
      router.app.$sMessage.warning(router.app.$t('Order.anotherUnitOrder'));
      return false;
    } else {
      next();
      return true;
    }
  }).catch(() => {
    router.app.$sMessage.error(router.app.$t('Error.somethingWentWrong'));
    return false;
  }).finally(() => {
    loader.show = false;
  });
};

export default sameUnitOrdersGuard;
